<template>
  <!--
          作者：gmshop
          时间：2019-10-25
          描述：会员-用户列表
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户ID"><el-input v-model="formInline.user_id" placeholder="用户ID" style="width:120px"></el-input></el-form-item>
        <el-form-item label="名称或手机"><el-input v-model="formInline.real_name" placeholder="请输入名称或手机" style=""></el-input></el-form-item>


        <el-form-item label="注册时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.reg_date" type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>

      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @sort-change="sortChange">
          <el-table-column prop="user_id" label="ID" width="80" sortable="custom"></el-table-column>
          <!-- <el-table-column prop="nickName" label="昵称"></el-table-column> -->
          <el-table-column prop="nickName" label="用户" width="300">
            <template slot-scope="scope">
              <div class="d-s-c">
               <!-- <img :src="scope.row.avatarUrl" width="60px" height="60px" /> -->
                <div class="ml10">
                  <p class="f14 fb">{{ scope.row.real_name }} </p>
                  <p class="gray3" v-if="scope.row.mobile">手机：{{ scope.row.mobile }}</p>
                  <p class="gray9">性别：{{ scope.row.gender | convertSex }}</p>
                  <!-- <p class="gray9" v-if="scope.row.referee_id">推荐人ID：{{ scope.row.referee_id }} {{scope.row.referee}}</p>
                  <p class="gray9" v-if="scope.row.referee_id && scope.row.user_referee!=null">
                    推荐人：{{ scope.row.user_referee.nickName }} [<span class="golden">{{ grade[scope.row.user_referee.grade_id].name }}</span>]

                  </p>
                   <p class="gray9" v-if="scope.row.open_id">
                    小程序OpenID：【{{ scope.row.open_id }}】

                  </p> -->
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="total_points" label="总积分" sortable="custom" align="center"></el-table-column>
          <el-table-column prop="points" label="可用积分" sortable="custom" align="center"></el-table-column>
          <!-- <el-table-column prop="balance" label="余额" sortable="custom" align="center"></el-table-column>
          <el-table-column prop="invite_code" label="邀请码" sortable="custom" align="center"></el-table-column>
          <el-table-column prop="referees_count" label="直推人数" sortable="custom" align="center">
            <template slot-scope="scope">
              <span @click="gotoPage('/user/structure/index', {user_id:scope.row.user_id})">{{ scope.row.referees_count }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="agent_log_sum" label="佣金" sortable="custom" align="center">
            <template slot-scope="scope">
              <span @click="gotoPage('/user/agent/index', {user_id:scope.row.user_id})">{{ scope.row.agent_log_sum }}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="unit.unit_name" label="所属单位"  align="center"></el-table-column>
          <el-table-column prop="group.unit_group_name" label="所属团队" align="center"></el-table-column>
         <!-- <el-table-column prop="province" label="省市">
            <template slot-scope="scope">
              {{ scope.row.province + scope.row.city }}
            </template>
          </el-table-column> -->
          <el-table-column prop="team_text" label="是否是队长" width="140" ></el-table-column>
          <el-table-column prop="create_time" label="注册时间" width="140" sortable="custom"></el-table-column>
          <!-- <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">

              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/user/user/grade'">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/user/user/delete'">删除</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>



    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="info" @click="cancelFunc">返回</el-button>

    </div>
  </div>
</template>

<script>
import UserApi from '@/api/unit.js';

import qs from 'qs';
export default {
  components: {

  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        nick_name: '',
        grade_id: '',
        user_id: '',
        reg_date: '',
        top_user_id:'',
        unit_group_id:'',
        real_name:'',
        unit_id:''
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      /*等级*/
      gradeList: [],
      grade: [],
      open_upload:false,
      unit:[],
      group:[]
    };
  },
  created() {
    this.formInline.unit_id =this.$route.query.unit_id;
    this.formInline.unit_group_id =this.$route.query.unit_group_id;
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*跳转页面*/
    gotoPage(path, query) {
      this.$router.push({
        path: path,
        query: query
      });
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.sort_name = self.sortName;
      Params.sort_value = self.sortValue;
      UserApi.userlist(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.unit = data.data.unit;
          self.gradeList = data.data.grade;
          data.data.grade.forEach((v,i) => {
            self.grade[v.grade_id] = v
          });
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let Params = self.formInline;
      self.getTableList();
    },
    initUnit(e){
      this.formInline.unit_group_id = '';
      this.unit.forEach(item=>{
        if(item.unit_id == e){
          this.group = item.group
        }
      })
      console.log(e)
    },
    /*排序查询*/
    sortChange(e){
      if (e.order && e.order != null){
        this.sortName = e.prop;
        this.sortValue = e.order=='ascending' ? 'asc' : 'desc';
      }else{
        this.sortName = this.sortValue = '';
      }
      this.tableData = [];
      this.getTableList();
    },

    /*打开添加*/
    addClick(item) {
      this.$router.push('/user/user/add');
    },
    /*打开编辑*/
    editClick(row) {
      let self = this;
      let params = row.user_id;
      this.$router.push({
        path: '/user/user/edit',
        // name: 'mallList',
        query: {
          user_id: params
        }
      });
    },
    rechargeClick(item){
      this.userModel = item;
      this.open_add = true;
    },
    /*打开编辑*/
    // editClick(item) {
    //   this.userModel = item;
    //   this.open_edit = true;
    // },
    onExport: function() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/user.user/export?' + qs.stringify(this.formInline);
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'upload') {
        this.open_upload = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
    },

    /*删除用户*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          UserApi.deleteuser(
            {
              user_id: row.user_id
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，用户删除成功',
                  type: 'success'
                });
                self.getTableList();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          self.loading = false;
        });
    },
    /*批量导入*/
    openUpload() {
      this.open_upload = true;
    },
    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/unit/group/userlist.vue